import ListModel from '../../models/lists/ListModel.js';
import FeatureTagsManagerView from '../../FeatureTagsManagerView.js';

const ListsCollection = Backbone.Collection.extend({

  model: ListModel,

  initialize() {
    this.pageCount = null;

    this.serviceTitle = window.lookup('Social');

    this.featureTagsManagerView = new FeatureTagsManagerView();
  },

  sync(method, collection, options) {
    const { username } = loginContext.getCurrentDetails();
    const { password } = loginContext.getCurrentDetails();
    const params = _.omit($.extend(true, {}, options), ['parse', 'success', 'silent', 'reset', 'remove', 'error', 'refreshCache']);
    const cache = new Cache();
    const cacheDurationMinutes = 15;
    let data;
    const defer = $.Deferred();

    // options.reset = ( method === "read" ) ? false : true; // update takes boolean, if set true update function will be called. Update cannot be called with data
    options.reset = (options.reset === undefined ? true : options.reset);
    options.refreshCache = options.refreshCache || false;

    params.username = username;
    params.api_key = password;
    params.application_id = window.sendible_application_id;
    params.category_code = params.category_code || '';

    // process cache key
    const key = this.processCacheKey(params);

    // if no cache then run sendible connect
    if (cache.read(key) === null || options.refreshCache) {
      Sendible.Connect.serviceGroups('', params, _.bind(function (data1) {
        data1.service_groups = this.processFetchedData(data1.service_groups);

        options.success(data1.service_groups);
        defer.resolve(data1.service_groups);
        cache.store(key, JSON.stringify(data1.service_groups), null, null, cacheDurationMinutes);
      }, this), (data1) => {
        if (options.error) options.error(data1);
        defer.reject(data1);
      });
    } else {
      data = JSON.parse(cache.read(key));
      data = this.processFetchedData(data);

      options.success(data);
      defer.resolve(data);
    }

    const promise = defer.promise();
    return promise;
  },

  remove(models, options) {
    // run the method we are overriding first
    Backbone.Collection.prototype.remove.call(this, models, options);

    // loop models and run delete APIs
    /* _.each(models, function(model){
            params = {};
            params.list_id = model.get("id");

            model.destroy();
            Sendible.Connect.deleteList("", params, function(data){
                options.success(data);
            }, function (data) {
                if(options.error) options.error( data );
            });
        }); */
  },

  updateCache() {
    const cache = new Cache();
    const params = '';

    // process cache keys
    const key = this.processCacheKey(params);

    cache.removeLike(key);
  },

  processCacheKey(options) {
    let key = 'ServiceGroups_';
    const keyObjects = $.extend(true, {}, options);
    const { username } = loginContext.getCurrentDetails();

    if (keyObjects.hasOwnProperty('category_code')) keyObjects.category_code = keyObjects.category_code.replace(',', '');

    key += `${username}_` || '';
    key += keyObjects.category_code || '';

    return key;
  },

  processFetchedData(data) {
    if (this.featureTagsManagerView.isFeatureTag('hideSendible')) {
      const hideAccounts = _.reduce(data, (arAccounts, account) => {
        if (account.name === 'YouTube'
                    || account.name === 'Pinterest') {
          arAccounts.push(account);
        }
        return arAccounts;
      }, []);

      return _.difference(data, hideAccounts);
    }
    return data;
  },

});

export default ListsCollection;
